import React, { useEffect, useState } from "react";
import { ReactComponent as Logo } from '../assets/icons/logo.svg';
import { ReactComponent as Echo } from '../assets/icons/echo.svg';
import { ReactComponent as Analytics } from '../assets/icons/analytics.svg';
import { ReactComponent as TelegramIcon } from "../assets/icons/telegram_bot.svg";
import { ReactComponent as UserIcon } from "assets/icons/user.svg";
import { ReactComponent as HamburgerIcon } from "../assets/icons/hamburger.svg";
import { SelectDropdown } from "commons/input-controls";
import s from "./header.module.scss"
import EchoButton from "../items/echo-button/echo-button";
import MobileMenu from "./mobile-menu/mobile-menu";

const LandingHeader = (props) => {

    const [menuItems, setMenuItems] = useState(props.menu);
    const [language, setLanguage] = useState(props.selectedLanguage);
    const [selected, setSelected] = useState(props.activeMenu);
    const [isShowMobileMenu, setIsShowMobileMenu] = useState(props.isShowMobileMenu);
    
    useEffect(() => {
        setMenuItems(props.menu);
        setLanguage(props.selectedLanguage);
        setSelected(props.activeMenu);
        setIsShowMobileMenu(props.isShowMobileMenu);
    }, [props]);

    const setSelectedLanguage = (language) => {
        setLanguage(language.short_name);
        props.setSelectedLanguage(null, language.short_name);
        props.setAuthLanguage(language.short_name);
    }   

    const setMenu = (selected, link) => {

        props.setMenuActive(selected)
        const el = document.getElementById(link);
        if(el)
            el.scrollIntoView({ block: 'end', inline: "nearest", behavior: "smooth" });

    }

    const showDemoModal = (isShow) => {
        props.setIsShowDemo(true)
    }

    const setShowMobileMenu = () => {
        props.setIsShowMobileMenu(!isShowMobileMenu);
    }

    const menu = menuItems.map( (k, i) => {return <button key={i} className={s.menuButton} onClick={setMenu.bind(this, k.name, k.title)}><span>{props.getValue(k.name)}</span></button>});

    const telegramButton = <div className={s.menuButtonF}><a href="https://t.me/joinchat/AAAAAEeRlKOBboDwly7h8A" target={'_blank'}><TelegramIcon /></a></div>

    const authButton = <EchoButton callback={setMenu.bind(this, "AUTHORIZATION")} icon={UserIcon} styles={{width: '36px', height: '36px', background: '#6AD699', borderRadius: '12px'}}/>
     
    const selectLanguage = <div className={s.selectLanguage}>
        <SelectDropdown selected={props.getValue(language)} items={props.LanguageItems} setSelected={setSelectedLanguage} styles={{width: '90px', background: '#F2F9FF33', borderRadius: '16px', color: "white", border: 'none'}} optionStyles={{color: 'white'}}/>
    </div>

    const getDemoAccess = <button onClick={showDemoModal} className={s.getMoreButton}>{props.getValue('REQUEST')}</button>

    const hamburgerMenu = <button className={s.hamburgerMenuButton} onClick={setShowMobileMenu}>{<HamburgerIcon />}</button>

    const mobileMenuItems = menuItems.map((k, i) => {return <button className={s.mobileMenuButton}><span>{props.getValue(k.name)}</span></button>});



    return (
        <div className={s.LandingHeader}>
            <div className={s.Logo} onClick={setMenu.bind(this, "main", "main")}>
                <Echo />
                <Analytics />
            </div>
            
            <div className={s.menuButtons}>
                <div className={s.menuButtonsBlock}>
                    {menu}
                </div>
                
                {selectLanguage}
                {telegramButton}
                {getDemoAccess}
                {authButton}
            </div>
            <div className={s.mobileMenuButtons}>
                { hamburgerMenu }
            </div>
            {isShowMobileMenu ? <MobileMenu getValue={props.getValue} items={menuItems} showMobileMenu={props.setIsShowMobileMenu} setMenu={setMenu}/> : null }
        </div>
    )
}

export default LandingHeader;